cb.define([], function() { //编辑 新增 商品模板
  var PC_pc_presentationclasslist_VM_Extend = {
    doAction: function(name, viewmodel) {
      if (this[name])
        this[name](viewmodel);
    },
    init: function(viewmodel) {
      viewmodel.on('beforeAdd', function(args) {
        if (args.params.params && args.params.params.cParameter == 'child' &&
          args.params.parent) {
          if (args.params.parent.level > 2) {
            cb.utils.alert('商品分类最多支持3级，已达到最大级次。', 'warning');
            return false;
          }
          //增加子类
          args.params.carryParams.id = args.params.parent.id;
          // args.params.carryParams.showInFront = args.params.parent.showInFront;
          //args.params.carryParams.iUOrderStatus = args.params.parent.iUOrderStatus;

        }
      });

      viewmodel.on('beforeBatchdelete', function(args) {
        let node = viewmodel.getTreeModel().getSelectedNodes()[0];
        if (!node.isEnd) {
          cb.utils.alert('存在下级分类，不能删除。', 'warning');
          return false;
        }
        return true;
      });
      const setStatus = function(nodes, status) {
        nodes.map(node => {
          if (node.level > 2) {
            status.push({
              "key": node.id,
              "itemName": "btnAddChild",
              "name": "visible",
              "value": false
            });
          }
          if (!node.isEnd) {
            status.push({
              "key": node.id,
              "itemName": "btnDelete",
              "name": "visible",
              "value": false
            });
          }
          if (node.children)
            setStatus(node.children, status)
        })
      }

      var treeModel = viewmodel.get('pc_presentationclasslist');
      treeModel.on('afterSetDataSource', function(data) {
        let status = []
        setStatus(data, status);
        treeModel.setActionsState(status);
      })
    }
  }
  try {
    module.exports = PC_pc_presentationclasslist_VM_Extend;
  } catch (error) {

  }
  return PC_pc_presentationclasslist_VM_Extend;
});


// WEBPACK FOOTER //
// ./src/client/business/PC/PC_pc_presentationclasslist_VM.Extend.js